/**
 * -----------------------------------------------------------------------------
 * These endpoints communicate to services providing asset tracker resources.
 * -----------------------------------------------------------------------------
 */

/**
 * The endpoint to get all the validating the login type for the user.
 */
export const validateLoginTypeUrl = () => 'api/login-type';

/**
 * The endpoint to get all the validating the login type for the user.
 */
export const validateLoginOtpUrl = () => 'api/login-otp';
